import { FolderTree } from "lucide-react";
import type { ViewerWorkspaceItem } from "@/types/user-data-viewer";

interface WorkspaceListProps {
  workspaces: ViewerWorkspaceItem[];
  onSelect: (workspace: ViewerWorkspaceItem) => void;
}

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("ko-KR");
}

export function WorkspaceList({ workspaces, onSelect }: WorkspaceListProps) {
  if (workspaces.length === 0) {
    return (
      <div className="rounded-lg border p-12 text-center text-sm text-muted-foreground">
        워크스페이스가 없습니다.
      </div>
    );
  }

  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {workspaces.map((workspace) => (
        <button
          key={workspace.id}
          type="button"
          onClick={() => onSelect(workspace)}
          className="flex flex-col gap-2 rounded-xl border bg-card p-4 text-left shadow-sm transition-colors hover:border-foreground/30 hover:bg-accent"
        >
          <div className="flex items-center gap-2">
            <FolderTree className="h-4 w-4 shrink-0 text-muted-foreground" />
            <span className="truncate font-medium">
              {workspace.name || "제목 없음"}
            </span>
          </div>
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <span>문서 {workspace.fileCount.toLocaleString()}개</span>
            <span>{formatDate(workspace.updatedAt)}</span>
          </div>
        </button>
      ))}
    </div>
  );
}
